// extracted by mini-css-extract-plugin
module.exports = {"summary":"_1WMgt3ywU6Qai1o7bYdm0Q","row":"_3GPzvSyJpd-v53NmvwFo_f"};